import featuredServiceTpl from './featured-service-card.tpl.html';
import featuredServiceInfoTpl from './featured-service-card-info.tpl.html';
import compactServiceTpl from './service-card-compact.tpl.html';

import listServiceTpl from './service-list-item.tpl.html';
import listServiceInfoTpl from './service-list-item-info.tpl.html';

import normalButtonComponentMod from '../../common/material-components/buttons/normal-button.component';
import normButtonComponentMod from '../../common/material-components/buttons/norm-button.component';
import nonCompatibleNotification from '../reservation/selections/non-compatible-notification.component';

import {serviceImageURL, serviceURL} from '../common/common.urls';
import urlServiceMod from '../common/url.service';

/**
 * Displays the details of a location in the locations page
 */
class ServiceCardComponent {

  constructor($window, $filter, $log, UrlService) {
    'ngInject';

    this.$window = $window;
    this.$filter = $filter;
    this.$log = $log;
    this.UrlService = UrlService;

    /**
     * @type {Service}
     */
    this.service = null;
    this.serviceId = null;

    this.showInfo = false;
    this.serviceInfoCallback = null;

    /**
     * Is the service card active.
     * @type {boolean}
     */
    this.active = false;

    this._serviceImage = '';

    this.oldMatches = [];

    this.reservationUrl = '';

    /**
     * @type {Location}
     */
    this.location = null;
    /**
     * @type {Person}
     */
    this.person = null;
  }

  $onInit() {
    this.serviceId = `service-${this.service.id}`;
    this.readMoreLink = this.service.url.length > 0 ? this.service.url : serviceURL(this.service);
    this._serviceImage = serviceImageURL(this.service);

    const reservationUrlParameters = {
      serviceId: this.service.id
    }

    if (this.location) reservationUrlParameters.locationId = this.location.id;
    if (this.person) reservationUrlParameters.personId = this.person.id

    this.UrlService.reservationURL(reservationUrlParameters)
      .then(url => this.reservationUrl = url);

    this.$log.debug("Card with service", this.service);
  }

  onServiceInfoClicked(event) {
    event.stopPropagation();
    this.serviceInfoCallback({service: this.service});
  }

  $doCheck() {
    const newMatches = angular.toJson(this.service.matches);
    if (!angular.equals(this.oldMatches, newMatches)) {
      this.oldMatches = newMatches;
      this.updateMatches();
    }
  }

  updateMatches() {
    // Create a string list of matches that are not directly visible, items are concatenated with comma
    try {
      const restOfMatches = [];
      if (this.service.matches) {
        this.$log.debug("Update matches", this.service.name, this.service.matches);

        for (const prop of ["category_names"]) {
          if (prop in this.service.matches) {
            restOfMatches.push(this.service.matches[prop].values.join(', '));
          }
        }
        this.service.restOfMatches = restOfMatches.join(', ');
      }
    }
    catch (e) {
      this.$log.debug("Service matches can't be set");
    }
  }
}

const config = {
  templateUrl: function($element, $attrs, $log) {
    $log.debug('Determining service card template to be used', $attrs.listMode, $attrs.showImage);

    if ($attrs.newStyle === "true") {
      if ($attrs.listMode === "true" && !$attrs.showInfo) {
        return listServiceTpl;
      }
      return compactServiceTpl;
    }
    // Attrs are unevaluated.
    if($attrs.listMode === "true") {
      if ($attrs.showInfo) {
        return listServiceInfoTpl;
      }
      else {
        return listServiceTpl;
      }
    } else {
      if ($attrs.showInfo) {
        return featuredServiceInfoTpl;
      }
      else {
        return featuredServiceTpl;
      }
    }
  },
  controller: ServiceCardComponent,
  bindings: {
    service: '<',
    listMode: '<',
    showImage: '<',
    showInfo: '<?',
    serviceInfoCallback: '&?',
    active: '<?',
    newStyle: '<?',
    location: '<?',
    person: '<?'
  }
};

const mod = angular.module('app.serviceCard', [
    urlServiceMod,
    normalButtonComponentMod,
    normButtonComponentMod,
    nonCompatibleNotification
  ])
.component('serviceCard', config)
;

export default mod.name;
